import { t } from "i18next";
import React from "react";
import { IS_AUTHOR } from "../../../constants/constants";
import FormRadioCheckboxField from "../../form/form-radio-field";

const FormAuthorRegistrationField = (props) => {
  const { handleRadioChange, setFieldValue } = props;

  return (
    <>
      <label htmlFor="authorRegistering" className="form-label">
        {t("are-you-author")}
      </label>
      <div className="form-group">
        <div className="form-check form-check-inline">
          <FormRadioCheckboxField
            label={t("yes")}
            fieldName="authorRegistering"
            type="radio"
            value={IS_AUTHOR.YES}
            handleChange={(event) => handleRadioChange(event, setFieldValue)}
          />
        </div>
        <div className="form-check form-check-inline">
          <FormRadioCheckboxField
            label={t("no")}
            className="form-check form-check-inline"
            fieldName="authorRegistering"
            type="radio"
            value={IS_AUTHOR.NO}
            handleChange={(event) => handleRadioChange(event, setFieldValue)}
          />
        </div>
      </div>
    </>
  );
};

export default FormAuthorRegistrationField;
